export default __webpack_public_path__ + "static/media/logoIcon.5ccb8451.svg";